import { render, staticRenderFns } from "./BrandInfo.vue?vue&type=template&id=7f71f3b0&scoped=true&"
import script from "./BrandInfo.vue?vue&type=script&lang=js&"
export * from "./BrandInfo.vue?vue&type=script&lang=js&"
import style0 from "../../less/store.less?vue&type=style&index=0&id=7f71f3b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f71f3b0",
  null
  
)

export default component.exports